<template>
  <div class="multiFilter-options-data-dialog">
    <el-collapse v-model="activeNames">
      <el-collapse-item class="dataContent" title="数据内容" name="1">
        <div class="dataSource-item mb16" @click="goToChooseData">
          <span>进入数据管理后台 </span>
        </div>
        <auto-update-timer :isLocal="false"/>
        <div class="mb16">
          <div class="getDataBtn" @click="getBaseModuleDataLoop">查看数据响应结果</div>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import autoUpdateTimer from "components/toolbar-option-components/utilsComponents/autoUpdateTimer/autoUpdateTimer.vue"
export default {
  name: "multiFilter-options-data",
  components: { autoUpdateTimer },
  props: {
    options: {
      type: Object
    }
  },
  data() {
    return {
      this1: this,
      activeNames: ["1"],
      collapseActiveNames: [],
      fetchEnd: false
    }
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    }
  },
  methods: {
    goToChooseData() {
      if (this.fetchEnd) return
      this.fetchEnd = true
      const { websiteId, pageId, sign, wfwfid, homePageId, pageType } = this.$store.state.states.getDataPageIds
      let target = this.getAttrById.call(this, this.$store.state[this.request_prefix], this.ids)
      let options = target.options ? target.options : target
      let { moduleId, appId } = options
      if (!!!moduleId || !!!appId) {
        // "31CB73E03E24BBFF" 对应 31CB73E03E24BBFF
        this.$saveModule(this.ids, "31CB73E03E24BBFF", "临时", false)
          .then(res => {
            this.fetchEnd = false
            console.log("$saveModule res", res)
            if (!!res.appId) {
              window.open(`/engine2/data/api-v2/admin/general/${res.appId}?w=${websiteId}&p=${pageId}&init=1`)
            }
          })
          .catch(err => (this.fetchEnd = false))
      }
      this.fetchEnd = false
      if (!!appId) window.open(`/engine2/data/api-v2/admin/general/${appId}?w=${websiteId}&p=${pageId}`)
    },
    async getBaseModuleDataLoop() {
      let nowComp = this.$event.contexts[this.request_prefix][this.$event.getIdsByStrId(this.ids)]
      nowComp.updateData()
    }
  }
}
</script>

<style lang="scss" scoped>
.dataContent {
  font-size: 14px;
  line-height: 22px;
  color: rgba(255, 255, 255, 0.8);
}
.getDataBtn {
  background: var(--themeColor);
  border-radius: 4px;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: #ffffff;
  padding: 6px 0px;
}
.getDataBtn:hover {
  cursor: pointer;
}
.dataSource-item {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  background: var(--leftMenuBgColor);
  border: 1px solid var(--themeColor);
  border-radius: 4px;
  font-size: 14px;
  color: var(--themeColor);
  &:hover {
    cursor: pointer;
  }
}
.dataUrl-item input {
  width: 252px;
  height: 32px;
  background: #35383f;
  color: rgba(255, 255, 255, 0.2);
}
.dataUrl-item .tips {
  color: var(--fourthTextColor);
}
</style>
